import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { Component, OnDestroy } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

import { SnCurrentUser, SnSessionService } from '@lib/auth';
import { AxonWelcomeModalComponent } from '../axon-welcome-modal/axon-welcome-modal.component';

@Component({
  selector: 'fs-welcome-modal-wrapper',
  templateUrl: './axon-welcome-modal-wrapper.component.html',
})
export class AxonWelcomeModalWrapperComponent implements OnDestroy {
  private readonly _destroy$ = new Subject<void>();

  constructor(
    private readonly _sessionService: SnSessionService,
    private readonly _matDialog: MatDialog,
    private readonly _currentUser: SnCurrentUser,
  ) {
    if (!this._sessionService.isAxonSso) return;
    if (this._currentUser.settings.mapSetting?.hasShownWelcome) return;

    const dialogRef = this._matDialog.open(AxonWelcomeModalComponent, {
      disableClose: true,
      panelClass: 'welcome-dialog-class',
    });

    // Update the hasShownWelcome setting only after the user closes the modal to avoid race conditions where multiple calls to updateSettings are made on app startup
    dialogRef
      .afterClosed()
      .pipe(takeUntil(this._destroy$))
      .subscribe(() => {
        this._currentUser
          .updateSettings({
            mapSetting: {
              ...this._currentUser.settings.mapSetting,
              hasShownWelcome: true,
            },
          })
          .subscribe();
      });
  }

  public ngOnDestroy(): void {
    this._destroy$.next();
    this._destroy$.complete();
  }
}
